import { API } from "../../constAPI";

const jsonHeaders = (token) => ({
  Authorization: `token ${token}`,
  Accept: "application/json",
  "Content-type": "application/json",
});

const parseResponse = async (response) => {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const message = data?.error || data?.message || data?.errors?.join(", ") || "Request failed";
    throw new Error(message);
  }
  return data;
};

export const getMatchResults = (filters, token) => {
  const params = new URLSearchParams();
  Object.entries(filters || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, value);
    }
  });

  return fetch(`${API}/api/admin/match-results?${params.toString()}`, {
    headers: jsonHeaders(token),
  }).then(parseResponse);
};

export const createMatchResult = (payload, token) => (
  fetch(`${API}/api/admin/match-results`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  }).then(parseResponse)
);

export const updateMatchResult = (id, payload, token) => (
  fetch(`${API}/api/admin/match-results/${id}`, {
    method: "PATCH",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  }).then(parseResponse)
);

export const voidMatchResult = (id, reason, token) => (
  fetch(`${API}/api/admin/match-results/${id}/void`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify({ reason }),
  }).then(parseResponse)
);

export const deleteMatchResult = (id, token) => (
  fetch(`${API}/api/admin/match-results/${id}`, {
    method: "DELETE",
    headers: jsonHeaders(token),
  }).then(parseResponse)
);

export const attachMatchResultToLeagueFixture = (id, payload, token) => (
  fetch(`${API}/api/admin/match-results/${id}/attach-league-fixture`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  }).then(parseResponse)
);

export const getCourts = (token) => (
  fetch(`${API}/api/courts`, {
    headers: jsonHeaders(token),
  }).then(parseResponse)
);

export const searchRegisteredPlayers = ({ search = "", page = 1, perPage = 50 } = {}, token) => {
  const params = new URLSearchParams({ search, page, perPage });
  return fetch(`${API}/api/matches/players?${params.toString()}`, {
    headers: jsonHeaders(token),
  }).then(parseResponse);
};
